export interface DashboardStats {
  totalRevenue: number;
  totalTrendyolRevenue: number;
  totalBoynerRevenue: number;
  totalHepsiburadaRevenue: number;
  totalN11Revenue: number;
  totalPazaramaRevenue: number;
  totalOrders: number;
  totalProducts: number;
  totalUsers: number;
}

export const dashboardStatsFromResponse = (
  responseData: any,
): DashboardStats => ({
  totalRevenue: responseData.total_revenue,
  totalTrendyolRevenue: responseData.total_trendyol_revenue,
  totalBoynerRevenue: responseData.total_boyner_revenue,
  totalHepsiburadaRevenue: responseData.total_hepsiburada_revenue,
  totalN11Revenue: responseData.total_n11_revenue,
  totalPazaramaRevenue: responseData.total_pazarama_revenue,
  totalOrders: responseData.total_orders,
  totalProducts: responseData.total_products,
  totalUsers: responseData.total_users,
});
